var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Information Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Glyph",
    d: "M11.3334 6.08332C11.3334 6.6611 10.9 7.16666 10.25 7.16666C9.60002 7.16666 9.16669 6.6611 9.16669 6.08332C9.16669 5.50555 9.67224 4.99999 10.25 4.99999C10.8278 4.99999 11.3334 5.50555 11.3334 6.08332ZM9.0278 14.1667C8.61113 14.1667 8.33335 13.9045 8.33335 13.5112C8.33335 13.118 8.61113 12.8558 9.0278 12.8558H9.58335C9.6528 12.8558 9.72224 12.7903 9.72224 12.7247V9.77527C9.72224 9.70973 9.6528 9.64418 9.58335 9.64418H9.0278C8.61113 9.64418 8.33335 9.38201 8.33335 8.98875C8.33335 8.5955 8.61113 8.33332 9.0278 8.33332H9.72224C10.4861 8.33332 11.1111 8.92321 11.1111 9.64418V12.7903C11.1111 12.8558 11.1806 12.9213 11.25 12.9213H11.8056C12.2222 12.9213 12.5 13.1835 12.5 13.5768C12.5 13.97 12.2222 14.1667 11.8056 14.1667H9.0278ZM10 1.66666C5.41669 1.66666 1.66669 5.41666 1.66669 9.99999C1.66669 14.5833 5.41669 18.3333 10 18.3333C14.5834 18.3333 18.3334 14.5833 18.3334 9.99999C18.3334 5.41666 14.5834 1.66666 10 1.66666Z",
    fill: "#0172CB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8959cbdf9095b2b5322d3fc4e25520ed.svg";
export { ForwardRef as ReactComponent };